import * as React from "react";
function SvgIconDownEnable(props) {
  return <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.168 4a.4.4 0 01.312.65L6.312 8.61a.4.4 0 01-.624 0L2.52 4.65A.4.4 0 012.832 4h6.336z" fill="#fff" opacity={0.7} /></svg>;
}
export default SvgIconDownEnable;